import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavigatorComponent, PageNavigatorService } from '@comparit/shared';
import {
  CustomIconsService,
  ExtRouteService,
  HeaderComponent,
  customDateAdapter,
} from '@comparit/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { HausratIconsService } from '../services/hausrat-icons.service';
import { ResultsService } from '../services/results.service';
import { SchutzOptimierenKatalogService } from '../services/schutz-optimieren/schutz-optimieren-katalog.service';

@Component({
  imports: [HeaderComponent, MatSidenavModule, RouterOutlet, NavigatorComponent],
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  providers: [customDateAdapter],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  private readonly _customIconsService = inject(CustomIconsService);
  private readonly _hausratIconsService = inject(HausratIconsService);
  private readonly _extRouteService = inject(ExtRouteService);
  private readonly navigatorService = inject(PageNavigatorService);
  private readonly schutzOptimierenKatalog = inject(SchutzOptimierenKatalogService);
  private readonly resultsService = inject(ResultsService);

  constructor() {
    this._customIconsService.init();
    this._hausratIconsService.init();
    // App-lifetime: the catalogue follows the funnel from here on, whichever step is open.
    this.schutzOptimierenKatalog.init();
    // Likewise the calculation trigger: it watches the funnel and runs while /rechner is open.
    this.resultsService.init();
  }

  protected showNavigator = computed(() => !this._extRouteService.url().endsWith('step1'));
  protected stepInfo = computed(() => this.navigatorService.setup()?.info);
}
